module.exports = __webpack_public_path__ + "img/web-disabled.5822e8cf.svg";